const data = {
  id: 0,
  curation: require("./2/curation").default,
};

export default data;
